import React from 'react'
import IntlTelInput from "react-intl-tel-input";
import SglContext from '../SglContext';
import "react-intl-tel-input/dist/main.css";
import "../entries/entries.css"

const axios = require("axios").default;

//API END POINTS
// const sgl_webservice_digisign = Sgl.nestApiUrl + '/entries/DigitalSignatures';

// const user_info_url = Sgl.nestApiUrl + '/users/getLoggedInUser';
// const sgl_webservice_digisign_link = Sgl.sglApiUrl + '/iphone.php/webservice/SendDigiSignURL';

const credit_company = process.env.REACT_APP_CREDIT_COMPANY;
const credit_text = process.env.REACT_APP_CREDIT_TEXT;
const credit_url = process.env.REACT_APP_CREDIT_URL;

class DigitalSignatures extends React.Component {

  get sgl_webservice_digisign() {
    return this.context.nestApiUrl + '/entries/DigitalSignatures';
  }

  get user_info_url() {
    return this.context.nestApiUrl + '/users/getLoggedInUser';
  }

  get sgl_webservice_digisign_link() {
    return this.context.sglApiUrl + '/iphone.php/webservice/SendDigiSignURL';
  }

  state = {
    loading: true,
    userData: {},
    has_pending_entries: false,
    error_message: "",
    mobile_number: "",
    phone_component: ""
  }

  constructor() {
    super();
  }

  componentDidMount() {
    document.title = "Digital Signatures";
    this.getAllData();

  }


  getDigiSignData() {
    axios.get(this.sgl_webservice_digisign, {
      params: {
        customer_id: this.context.company_id,
        team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
      }
    }).then(res => {
      if (res.data.success) {
        if (res.data.sign_url) {
          window.location = res.data.sign_url;
        } else {
          this.setState({
            has_pending_entries: true,
            loading: false,
            // mobile_phone: res.data.mobile_phone,
          });
        }
      } else {
        this.setState({
          has_pending_entries: false,
          loading: false,
          error_message: res.data.message
        });
      }
    })

  }

  getAllData() {
    this.getUserData();
    this.getDigiSignData();
  }

  getUserData() {
    axios.get(this.user_info_url)
      .then((response) => {
        this.context.checkLoginOnSGL();
        if (response.data.user && response.data.user != null) {
          this.setState({
            userData: response.data.user,
          });
        } else {
        }
      }, (error) => {
      });
  }

  sendLink() {
    this.setState({
      success_message: "",
    });

    let mobile_number = document.getElementById('phone_number')
    if (mobile_number) {
      mobile_number = mobile_number.value;
      if (!mobile_number) {
        this.setState({
          error_message: "Please provide valid mobile number",
        });
      } else {
        this.setState({
          error_message: "",
        });

        axios.post(this.sgl_webservice_digisign_link, null, {
          params: {
            mobile_phone: mobile_number,
            customer_id: this.context.company_id
          }
        })
          .then((response) => {
            if (response.data.success) {
              this.setState({
                success_message: "SMS with a link to sign your entries is sent at " + mobile_number,
              });
            } else {
              this.setState({
                error_message: response.data.error,
              });
            }
          });

      }
    }
  }

  handleBlur(status, phoneNumber, country, formattedValue) {
    this.setState({ 'phone_number': phoneNumber, 'status': status });

    if (status) {
      document.getElementById('phone_number').value = formattedValue;
      document.querySelector("#valid_msg").classList.remove('hide');
    } else {
      document.querySelector("#valid_msg").classList.add('hide');
      document.getElementById('phone_number').value = '';
    }

  }

  reset() {
    let phone_input_hidden = document.getElementById("phone_number");
    phone_input_hidden.value = "";
  }


  render() {
    const loading = this.state.loading;
    if (loading) {
      return null;
    }

    return (
      <div className="sgl-plugin">
        <div id='digital_signatures'>
          <div className="credit-text">{credit_text} <a href={credit_url}>{credit_company}</a></div><br />
          <div id="ringWrapper" className='ringWrapper'>
            <div className="div-responsive" style={{ overflowX: "visible" }}>
              <div id="step_1_container" className='sgl-primary-header class-details primary-header class-details-header sgl-primary-header active_block' rowNum="1">
                <p id="step_1_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name ">Digital Signatures</p>
              </div>
              <div id='step_1' className='add_entry_class add-entry-div'>
                {
                  (this.state.has_pending_entries) &&
                  <ul>
                    <li className='entry_people_li'>
                      <label className='add_entry_label'>
                        Please enter your Mobile Number.<br />
                        Enter your complete number including country code i.e +1 (828) 202-8116.
                      </label>
                      <div style={{ clear: "both" }}></div>
                      <div className='txt-field-container-div' style={{display:"flex"}}>
                        <input
                          type="hidden"
                          className="digital_signature_phonenumber"
                          id="phone_number"
                          name="phone_number"
                        />
                        <IntlTelInput
                          style={{
                            width: "100%",
                          }}
                          dropdownContainer={document.body}
                          nationalMode={true}
                          formatOnDisplay={true}
                          format={true}
                          placeholder={"(201) 555-0123"}
                          initialCountry={"us"}
                          utilsScript={"https://showgroundslive.com/js/utils.js"}
                          preferredCountries={["us", "ca"]}
                          onPhoneNumberChange={this.handleBlur.bind(this)}
                          onKeyUp={this.reset.bind(this)}
                          onChange={this.reset.bind(this)}
                          name="phone_number_input"
                          id="phone_number_input"
                          value={this.state.phone_number}
                        />
                        <span id="valid_msg" className="hide">
                          <img src={"https://showgroundslive.com/images/tick_icon.png"} style={{ marginLeft: '7px', marginTop: '7px', width: '16px', height: '16px' }} />
                        </span>

                      </div>
                      <button onClick={evt => this.sendLink()} style={{ float: "left", marginTop: "10px", 'clear': 'both', 'display': 'block' }} className="sgl-button">Send Link</button>
                    </li>
                  </ul>
                }

                <div style={{ clear: "both" }}></div>

                {
                  (this.state.error_message) &&
                  <div style={{ 'clear': 'both', paddingTop: '10px', 'color': 'red' }} id='digisign_pending'>
                    <span>{this.state.error_message}</span>
                  </div>
                }

                {
                  (this.state.success_message) &&
                  <div style={{ 'clear': 'both', paddingTop: '10px', 'color': 'green' }} id='digisign_pending'>
                    <span>{this.state.success_message}</span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

// ReactDOM.render(<DigitalSignatures />, document.getElementById("sgl-content-wrapper"));
DigitalSignatures.contextType = SglContext;
export default DigitalSignatures;